import { Theme } from '@mui/material';
import { makeStyles } from '@mui/styles';
import Colors from '../../entities/colors';

export default makeStyles(({ spacing }: Theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    height: '250px',
  },
  dragContainer: {
    backgroundColor: '#6B6B6E',
    display: 'flex',
    padding: spacing(2),
    width: '100%',
    height: '100%',
  },
  dragArea: {
    border: '2px dotted #E1E8F6',
    borderRadius: '10px',
    width: '100%',
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: spacing(2),
  },
  dragging: {
    border: '2px dotted #E1E8F6',
    borderRadius: '10px',
    padding: '16px',
    width: '100%',
    height: '100%',
    textAlign: 'center',
    background: Colors.N200,
  },
  defaultContent: {
    width: '100px',
    height: '105px',
    backgroundSize: 'cover',
    margin: '22px auto',
  },
  preview: {
    width: '100%',
    height: '100%',
    borderRadius: 'inherit',
    backgroundSize: 'contain',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    cursor: 'pointer',
    position: 'relative',

    '& > div': {
      width: '100%',
      height: '100%',
      display: 'none',
      borderRadius: '10px',
      position: 'absolute',
      background: '#DE3C4B',
      opacity: '0.8',
    },

    '&:hover > div': {
      display: 'flex !important',
      justifyContent: 'center',
      alignItems: 'center',
    },
  },
  helpText: {
    margin: '4px 0px',
    color: '#BBC1CC',
    fontWeight: 700,
  },
  link: {
    color: '#BBC1CC',
    fontWeight: 700,
    fontFamily: 'Gilroy',
    textDecoration: 'underline',
    verticalAlign: 'baseline',
    display: 'inline',
    cursor: 'pointer',
  },
  fileTypes: {
    margin: '4px',
    color: '#A8AEB8',
    fontWeight: 400,
  },
  icon: {
    color: '#BBC1CC',
    position: 'absolute',
    right: '25px',
    bottom: '25px',
  },
}));
